import { Card, Button, Form, Row, Modal } from "react-bootstrap";
import MaterialTable, {
    Column,
    EditComponentProps,
} from "@material-table/core";
import React, { useState, useEffect, useCallback, useRef } from "react";
import * as APIModels from "../../../../models";
import { FileService } from "../../../../services/SubmissionService";
import { useDropzone } from "react-dropzone";
import Select, { ActionMeta } from "react-select";
import {
    TylerDataService,
    DataService,
} from "../../../../services/DataService";
import { responsiveProperty } from "@mui/material/styles/cssUtils";
import { parseFullName } from "parse-full-name";
import { Address } from "../../../../models/swagger/generated-submission-service";

type MyOptionType = { label: string; value: string };
type AddressOptionType = { label: string; value: APIModels.ServiceContact };

export default function PartyModal({
    show,
    party,
    partyTypes,
    attorneys,
    onSaveParty,
    parties,
    close,
}: {
    show: boolean;
    party: APIModels.Party;
    partyTypes: APIModels.PartyType[];
    attorneys: APIModels.Attorney[];
    onSaveParty: (party: APIModels.Party) => void;
    parties: APIModels.Party[];
    close: () => void;
}) {
    const [completedParty, setCompletedParty] = useState(party);
    const [addresses, setAddresses] = useState([] as AddressOptionType[]);
    const [defaultAddresses, setDefaultAddresses] = useState(
        [] as AddressOptionType[]
    );
    const [partyTypeOptions, setPartyTypeOptions] = useState(
        [] as MyOptionType[]
    );
    const [attorneyOptions, setAttorneyOptions] = useState(
        [] as MyOptionType[]
    );
    const [stateOptions, setStateOptions] = useState([] as MyOptionType[]);
    const [errorMessage, setErrorMessage] = useState("");
    const [orgString, setOrgString] = useState("");

    const partyTypeRef = useRef(null);
    const fNameInput = useRef<HTMLInputElement>(null);
    const lNameInput = useRef<HTMLInputElement>(null);
    const orgInput = useRef<HTMLInputElement>(null);

    const streetInput = useRef<HTMLInputElement>(null);
    const cityInput = useRef<HTMLInputElement>(null);
    const zipInput = useRef<HTMLInputElement>(null);

    const eventAddress = new Address();

    const [eventAddressState, setEventAddressState] = useState(eventAddress);

    const [isEventAddressUpdated, setIsEventAddressUpdated] = useState(true);

    const [isAddressUpdated, setIsAddressUpdated] = useState(true);

    const [isOrganization, setIsOrganization] = useState(false);

    useEffect(() => {
        setPartyTypeOptions(
            partyTypes.map((p, _i) => {
                return { label: p.description ?? "", value: p.ePortalID ?? "" };
            })
        );

        DataService.getStates().then(
            (resp) => {
                const options = resp.map((v, _i) => {
                    return { label: v.name ?? "", value: v.abbreviation ?? "" };
                });

                setStateOptions(options);
            },
            (error) => {
                console.log(error);
            }
        );
    }, [partyTypes]);

    useEffect(() => {
        console.log(attorneys);
        setAttorneyOptions(
            attorneys.map((p, _i) => {
                return {
                    label:
                        p.firstName +
                        " " +
                        (p.middleName ?? "") +
                        " " +
                        p.lastName,
                    value: p.ePortalID ? p.ePortalID : p.id,
                } as MyOptionType;
            })
        );
    }, [attorneys]);

    useEffect(() => {
        if (isEventAddressUpdated === false) {
            const temp = {
                ...completedParty,
                address: {
                    streetAddress: eventAddressState.streetAddress,
                    unit: eventAddressState.unit,
                    city: eventAddressState.city,
                    zip: eventAddressState.zip,
                    state: eventAddressState.state,
                },
            };
            setCompletedParty({
                ...temp,
            });
        }
        setIsEventAddressUpdated(true);
    }, [isEventAddressUpdated]);

    const populateOrgParty = (msg: any, data: string) => {
        const temp = { ...completedParty };

        if (data!.length > 0) {
            fNameInput.current?.removeAttribute("required");
            lNameInput.current?.removeAttribute("required");

            orgInput.current?.setAttribute("required", "required");
        } else {
            fNameInput.current?.setAttribute("required", "required");
            lNameInput.current?.setAttribute("required", "required");
            orgInput.current?.setAttribute("required", "required");
        }

        let partyName = "";
        if (msg === "plaintiffOrgEvent") {
            partyName = "Plaintiff";

            const party = partyTypes.find(
                (c) => c.description?.toLowerCase() === partyName.toLowerCase()
            );

            const temp = {
                ...completedParty,
                name: data,
                partyTypeCode: party?.ePortalID,
                partyType: party?.description,
            };

            setCompletedParty({ ...temp });
        } else if (msg === "defendantOrgEvent") {
            partyName = "Defendant";

            const party = partyTypes.find(
                (c) => c.description?.toLowerCase() === partyName.toLowerCase()
            );

            setCompletedParty({
                ...temp,
                name: data,
                partyTypeCode: party?.ePortalID,
                partyType: party?.description,
            });
        }
    };

    const populateIndividualParty = (msg: any, data: string) => {
        const name = parseFullName(data);

        let partyName = "";

        if (name.first!.length > 0 && name.last!.length > 0) {
            orgInput.current?.removeAttribute("required");
        } else {
            fNameInput.current?.setAttribute("required", "required");
            lNameInput.current?.setAttribute("required", "required");
            orgInput.current?.setAttribute("required", "required");
        }
        if (msg === "plaintiffEvent") {
            partyName = "Plaintiff";

            const party = partyTypes.find(
                (c) => c.description?.toLowerCase() === partyName.toLowerCase()
            );

            const temp = {
                ...completedParty,
                firstName: name.first,
                middleName: name.middle,
                lastName: name.last,
                partyTypeCode: party?.ePortalID,
                partyType: party?.description,
            };

            setCompletedParty({ ...temp });
        } else if (msg === "defendantEvent") {
            partyName = "Defendant";

            const party = partyTypes.find(
                (c) => c.description?.toLowerCase() === partyName.toLowerCase()
            );

            const temp = {
                ...completedParty,
                firstName: name.first,
                middleName: name.middle,
                lastName: name.last,
                partyTypeCode: party?.ePortalID,
                partyType: party?.description,
            };

            setCompletedParty({ ...temp });
        }
    };
    const partyOrganizationHandler = (msg: any, data: string) => {
        populateOrgParty(msg, data);

        if (isAddressUpdated === true) setIsAddressUpdated(false);
        else if (isAddressUpdated === false) setIsAddressUpdated(true);
    };

    const partyIndividualHandler = (msg: any, data: string) => {
        populateIndividualParty(msg, data);

        if (isAddressUpdated === true) setIsAddressUpdated(false);
        else if (isAddressUpdated === false) setIsAddressUpdated(true);
    };

    useEffect(() => {
        if (isAddressUpdated === false) {
            if (
                completedParty.partyType != undefined &&
                (completedParty.partyType!.toLowerCase().indexOf("plaintiff") >
                    -1 ||
                    completedParty.partyType!.toLowerCase().indexOf("pet") >
                        -1 ||
                    completedParty.partyType!.toLowerCase().indexOf("assign") >
                        -1)
            ) {
                const addressOption = addresses.filter(
                    (a) => a.label.indexOf("Attorney") > -1
                )[0];
                console.log(addressOption);

                const temp = {
                    ...completedParty,
                    address: {
                        streetAddress:
                            addressOption?.value.address?.streetAddress,
                        unit: addressOption?.value.address?.unit,
                        city: addressOption?.value.address?.city,
                        zip: addressOption?.value.address?.zip,
                        state: addressOption?.value.address?.state,
                    },
                };
                setCompletedParty({ ...temp });
            } else {
                const temp = {
                    ...completedParty,
                    address: {
                        streetAddress: "",
                        unit: "",
                        city: "",
                        zip: "",
                        state: "",
                    },
                };
                setCompletedParty({ ...temp });
            }
        }

        setIsAddressUpdated(true);
    }, [isAddressUpdated]);

    useEffect(() => {
        setCompletedParty(party);
    }, [party]);

    useEffect(() => {
        const options = parties.map((v, i) => {
            return {
                label: v.name ?? v.firstName + " " + v.lastName,
                value: {
                    fullName: v.name ?? v.firstName + " " + v.lastName,
                    address: v.address,
                },
            };
        });

        const addressOptions = [...defaultAddresses, ...options];
        setAddresses(addressOptions);
    }, [parties]);

    const onPartyTypeChange = (
        value: MyOptionType | null,
        actionMeta: ActionMeta<MyOptionType>
    ) => {
        const partyTypeName = value?.label ?? "";
        setErrorMessage("");

        if (
            partyTypeName.toLowerCase().indexOf("plaintiff") > -1 ||
            partyTypeName.toLowerCase().indexOf("pet") > -1 ||
            partyTypeName.toLowerCase().indexOf("assign") > -1
        ) {
            const addressOption = addresses.filter(
                (a) => a.label.indexOf("Attorney") > -1
            )[0];

            setCompletedParty({
                ...completedParty,
                partyType: value?.label,
                partyTypeCode: value?.value,
                address: {
                    streetAddress: addressOption?.value.address?.streetAddress,
                    unit: addressOption?.value.address?.unit,
                    city: addressOption?.value.address?.city,
                    zip: addressOption?.value.address?.zip,
                    state: addressOption?.value.address?.state,
                },
            });
        } else {
            setCompletedParty({
                ...completedParty,
                partyType: value?.label,
                partyTypeCode: value?.value,
            });
        }
    };

    const onOrganizationNameChange = (
        event: React.FormEvent<HTMLInputElement>
    ) => {
        event.preventDefault();

        setCompletedParty({
            ...completedParty,
            name: event.currentTarget.value,
        });

        if (event.currentTarget.value.length > 0) {
            fNameInput.current?.removeAttribute("required");
            lNameInput.current?.removeAttribute("required");

            orgInput.current?.setAttribute("required", "required");
        } else {
            fNameInput.current?.setAttribute("required", "required");
            lNameInput.current?.setAttribute("required", "required");
            orgInput.current?.setAttribute("required", "required");
        }
    };

    const onSubmit = () => {
        console.log(completedParty);
        if (completedParty.partyTypeCode && completedParty.partyTypeCode != "")
            onSaveParty(completedParty);
        else setErrorMessage("Please select the party type");

        return false;
    };

    const filterOption = (option: MyOptionType, inputValue: string): boolean =>
        (
            option.label
                .toString()
                .toLowerCase()
                .match(inputValue.toLowerCase()) || []
        ).length > 0;
    return (
        <Modal show={show} size="lg" centered>
            <div className="modal-header">
                Party Information
                <button
                    type="button"
                    className="close"
                    aria-label="Close"
                    onClick={() => close()}
                >
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div className="modal-body">
                <div className="row mb-3">
                    <div className="col-sm-12">
                        <label htmlFor="selPartyType" className="form-label">
                            Party Type
                        </label>
                        <Select
                            ref={partyTypeRef}
                            id="selPartyType"
                            name="selPartyType"
                            value={partyTypeOptions.filter(
                                (c) => c.value === completedParty.partyTypeCode
                            )}
                            filterOption={filterOption}
                            options={partyTypeOptions}
                            onChange={onPartyTypeChange}
                            required
                        />
                    </div>
                </div>
                {!isOrganization ? (
                    <div className="row mb-3">
                        <div className="col-sm-3">
                            <label htmlFor="txtFName" className="form-label">
                                First Name
                            </label>
                            <div className="input-group">
                                <input
                                    ref={fNameInput}
                                    type="text"
                                    className="form-control"
                                    id="txtFName"
                                    placeholder="First Name"
                                    aria-describedby="inputGroupPrepend"
                                    value={completedParty.firstName ?? ""}
                                    onChange={(event) => {
                                        setCompletedParty({
                                            ...completedParty,
                                            firstName:
                                                event.currentTarget.value,
                                        });

                                        if (
                                            event.currentTarget.value.length > 0
                                        ) {
                                            orgInput.current?.removeAttribute(
                                                "required"
                                            );

                                            lNameInput.current?.setAttribute(
                                                "required",
                                                "required"
                                            );
                                        } else {
                                            orgInput.current?.setAttribute(
                                                "required",
                                                "required"
                                            );
                                        }
                                    }}
                                    required
                                />
                            </div>
                        </div>
                        <div className="col-sm-3">
                            <label htmlFor="txtMName" className="form-label">
                                Middle Name
                            </label>
                            <div className="input-group">
                                <input
                                    type="text"
                                    className="form-control"
                                    id="txtMName"
                                    placeholder="Middle Name"
                                    aria-describedby="inputGroupPrepend"
                                    value={completedParty.middleName ?? ""}
                                    onChange={(event) => {
                                        setCompletedParty({
                                            ...completedParty,
                                            middleName:
                                                event.currentTarget.value,
                                        });
                                    }}
                                />
                            </div>
                        </div>
                        <div className="col-sm-3">
                            <label htmlFor="txtLName" className="form-label">
                                Last Name
                            </label>
                            <div className="input-group">
                                <input
                                    ref={lNameInput}
                                    type="text"
                                    className="form-control"
                                    id="txtLName"
                                    placeholder="Last Name"
                                    aria-describedby="inputGroupPrepend"
                                    value={completedParty.lastName ?? ""}
                                    onChange={(event) => {
                                        console.log("Hit Last name change");
                                        setCompletedParty({
                                            ...completedParty,
                                            lastName: event.currentTarget.value,
                                        });

                                        if (
                                            event.currentTarget.value.length > 0
                                        ) {
                                            orgInput.current?.removeAttribute(
                                                "required"
                                            );

                                            fNameInput.current?.setAttribute(
                                                "required",
                                                "required"
                                            );
                                        } else {
                                            orgInput.current?.setAttribute(
                                                "required",
                                                "required"
                                            );
                                        }
                                    }}
                                    required
                                />
                            </div>
                        </div>
                        <div className="col-sm-3">
                            <button
                                className="btn btn-primary mt-4"
                                onClick={() => setIsOrganization(true)}
                            >
                                Switch to Organization
                            </button>
                        </div>
                    </div>
                ) : (
                    <div className="row mb-3">
                        <div className="col-sm-9">
                            <label htmlFor="txtOrgName" className="form-label">
                                Organization Name
                            </label>
                            <div className="input-group">
                                <input
                                    ref={orgInput}
                                    type="text"
                                    className="form-control"
                                    id="txtOrgName"
                                    placeholder="Organization Name"
                                    aria-describedby="inputGroupPrepend"
                                    value={completedParty.name ?? ""}
                                    onChange={onOrganizationNameChange}
                                    required
                                />
                            </div>
                        </div>
                        <div className="col-sm-3">
                            <button
                                className="btn btn-primary mt-4"
                                onClick={() => setIsOrganization(false)}
                            >
                                Switch to Person
                            </button>
                        </div>
                    </div>
                )}
                <div className="row mb-3">
                    <div className="col-sm-6">
                        <label htmlFor="txtStreetAddr" className="form-label">
                            Street Address
                        </label>
                        <div className="input-group">
                            <input
                                ref={streetInput}
                                type="text"
                                className="form-control"
                                id="txtStreetAddr"
                                placeholder="Street Address"
                                aria-describedby="inputGroupPrepend"
                                value={
                                    completedParty.address?.streetAddress ?? ""
                                }
                                onChange={(event) =>
                                    setCompletedParty({
                                        ...completedParty,
                                        address: {
                                            ...completedParty.address,
                                            streetAddress:
                                                event.currentTarget.value,
                                        },
                                    })
                                }
                                required
                            />
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <label
                            htmlFor="txtStreetAddress2"
                            className="form-label"
                        >
                            Street Address 2
                        </label>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="txtStreetAddress2"
                                placeholder="Street Address 2"
                                aria-describedby="inputGroupPrepend"
                                value={completedParty.address?.unit ?? ""}
                                onChange={(event) =>
                                    setCompletedParty({
                                        ...completedParty,
                                        address: {
                                            ...completedParty.address,
                                            unit:
                                                event.currentTarget.value ?? "",
                                        },
                                    })
                                }
                            />
                        </div>
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col-sm-4">
                        <label htmlFor="txtCity" className="form-label">
                            City
                        </label>
                        <div className="input-group">
                            <input
                                ref={cityInput}
                                type="text"
                                className="form-control"
                                id="txtCity"
                                placeholder="City"
                                aria-describedby="inputGroupPrepend"
                                value={completedParty.address?.city ?? ""}
                                onChange={(event) =>
                                    setCompletedParty({
                                        ...completedParty,
                                        address: {
                                            ...completedParty.address,
                                            city: event.currentTarget.value,
                                        },
                                    })
                                }
                                required
                            />
                        </div>
                    </div>
                    <div className="col-sm-4">
                        <label htmlFor="txtMName" className="form-label">
                            State
                        </label>
                        <Select
                            id="selState"
                            name="selState"
                            value={stateOptions.filter(
                                (c) => c.value === completedParty.address?.state
                            )}
                            options={stateOptions}
                            onChange={(
                                value: MyOptionType | null,
                                actionMeta: ActionMeta<MyOptionType>
                            ) => {
                                setCompletedParty({
                                    ...completedParty,
                                    address: {
                                        ...completedParty.address,
                                        state: value?.value,
                                    },
                                });
                            }}
                            required
                        />
                    </div>
                    <div className="col-sm-4">
                        <label htmlFor="txtZip" className="form-label">
                            Zip
                        </label>
                        <div className="input-group">
                            <input
                                ref={zipInput}
                                type="text"
                                className="form-control"
                                id="txtZip"
                                placeholder="Zip"
                                aria-describedby="inputGroupPrepend"
                                value={completedParty.address?.zip ?? ""}
                                onChange={(event) =>
                                    setCompletedParty({
                                        ...completedParty,
                                        address: {
                                            ...completedParty.address,
                                            zip: event.currentTarget.value,
                                        },
                                    })
                                }
                                required
                            />
                        </div>
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col-sm-4">
                        <label htmlFor="selAttorney" className="form-label">
                            Attorney
                        </label>
                        <Select
                            id="selAttorney"
                            name="selAttorney"
                            value={attorneyOptions.filter(
                                (c) => c.value === completedParty.attorneyID
                            )}
                            options={attorneyOptions}
                            onChange={(
                                value: MyOptionType | null,
                                actionMeta: ActionMeta<MyOptionType>
                            ) => {
                                console.log({
                                    value: value?.value ?? "",
                                    label: value?.label ?? "",
                                });
                                // get the attorney by the ID
                                const attorneyToAdd = attorneys.filter(
                                    (attorney) => attorney.id === value?.value
                                )[0];

                                setCompletedParty({
                                    ...completedParty,
                                    attorneyID: value?.value,
                                    attorney: attorneyToAdd,
                                });
                            }}
                        />
                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <div style={{ color: "red", textAlign: "center" }}>
                    {errorMessage}
                </div>
                <button
                    className="btn btn-primary"
                    type="submit"
                    onClick={() => onSubmit()}
                >
                    Save Party
                </button>
            </div>
        </Modal>
    );
}
